var _circle, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOncallDept({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0B5CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4712 12.6441H16.5222V10.7213H23.4712V12.6441ZM20.4267 24.9596C23.0187 24.9596 25.12 22.8583 25.12 20.2663C25.12 17.6742 23.0187 15.5729 20.4267 15.5729C17.8346 15.5729 15.7333 17.6742 15.7333 20.2663C15.7333 22.8583 17.8346 24.9596 20.4267 24.9596ZM32.234 12.6451H31.4385H24.5938V10.159C24.5938 9.85087 24.3416 9.59961 24.0344 9.59961H15.959C15.6528 9.59961 15.3996 9.85087 15.3996 10.159V12.6451H8.55302H7.75752C7.45127 12.6451 7.20001 12.8935 7.20001 13.2035V19.4035C7.20001 20.144 7.50342 20.8153 7.99551 21.2979V29.8122C7.99551 30.1223 8.24487 30.3735 8.55302 30.3735H31.4385C31.7514 30.3735 32.0026 30.1223 32.0026 29.8122V21.2979C32.4919 20.8153 32.8 20.144 32.8 19.4035V13.2035C32.8 12.8935 32.544 12.6451 32.234 12.6451Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19641_15720",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.302 17.5996H19.451V19.4506H17.6V21.3016H19.451V23.1525H21.302V21.3016H23.1529V19.4506H21.302V17.5996Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19641_15720)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.515 14.5146H26.2379V26.2375H14.515V14.5146Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOncallDept);
export default __webpack_public_path__ + "static/media/oncall_dept.bf9f3cb690051f841ca3bdf42b38f67d.svg";
export { ForwardRef as ReactComponent };